import { Injectable } from '@angular/core';

// function getQueryParamsCompanyId() {

//   const urlParamsCompanyId = new URLSearchParams(window.location.search);
//   const companyId = urlParamsCompanyId.get('companyId');
//   return companyId
// }

@Injectable({
  providedIn: 'root'
})
export class UrlParamsService {




  constructor() { }

  getQueryParamsDevMode(): boolean {

    const urlParamsCompanyId = new URLSearchParams(window.location.search);
    const devMode = urlParamsCompanyId.get('devMode');
    return (devMode === 'true');
  }

   getQueryParamsCompanyId(): string  {

    const urlParamsCompanyId = new URLSearchParams(window.location.search);
    const companyId = urlParamsCompanyId.get('cId') as string;
    return companyId;
  }

  getQueryParamsSiteId(): string {

    const urlParamsSiteId = new URLSearchParams(window.location.search);
    const siteId = urlParamsSiteId.get('sId') as string;
    return siteId;
  }

  // getQueryParam(param: string): string {

  //   const urlParam = new URLSearchParams(window.location.search);
  //   return urlParam.get(param);
  // }

  getQueryParamsUserId(): string {

    const urlParamsUserId = new URLSearchParams(window.location.search);
    const userId = urlParamsUserId.get('userId') as string;
    return userId;
  }

  getQueryParamsUserEmail(): string {

    const urlParamsUserEmail = new URLSearchParams(window.location.search);
    const userEmail = urlParamsUserEmail.get('userEmail') as string;
    return userEmail;
  }

}
